import Vue from 'vue'
import App from './App.vue'
// import router from './router'
import store from './store'
import Navigation from 'vue-navigation'
import { Toast } from 'vant';
import _ from 'lodash'
import {hasOneOf, replaceAllText} from "@/libs/util";
import {reportError} from "@/api/report";
import {globalMixin} from "@/libs/mixin";
import axios from "axios";
export const badge = new Vue();
Vue.prototype._ = _;
Vue.use(Toast);
Toast.setDefaultOptions("loading", {duration:0})
axios.defaults.baseURL = '/gdLocation'

// Vue.use(Navigation, {router})
// 判断店铺是否有开通附加功能
Vue.prototype.$hasFeature = function (value){
  // 店铺6的自动在线功能比较特殊，是定时任务类型，店员不能自己操作
  if(value === 'auto_online' && store.state.shop.id === 6){
    return false
  }
  if(Array.isArray(value)){
    return value.every(this.$hasFeature)
  }
  return store.state.featureValue && store.state.featureValue.has(value)
}
Vue.prototype.$hasRole = function (role){
  return store.state.roles.includes(role)
}
// 判断用户权限有roles中的任一角色
Vue.prototype.$hasRolesAny = function(roles) {
  return hasOneOf(store.state.roles, roles)
}
// 替换标签
Vue.prototype.$replaceLabel = function(item, label, updateData) {
  return replaceAllText(item, label, updateData)
}
Vue.config.productionTip = false

if (!('toJSON' in Error.prototype))
Object.defineProperty(Error.prototype, 'toJSON', {
    value: function () {
        var alt = {};

        Object.getOwnPropertyNames(this).forEach(function (key) {
            alt[key] = this[key];
        }, this);

        return alt;
    },
    configurable: true,
    writable: true
});

// 获取全局数据
if (!store.state.hasGlobalData) {
  store.dispatch('getGlobalData').then(res => {
    const data = res.data
    if (data.code == 0) {

      const router = require('./router').default
      Vue.use(Navigation, { router: router })
      Vue.mixin(globalMixin)
      new Vue({
        router,
        store,
        render: h => h(App)
      }).$mount('#app')
    } else {
      console.log('初始化失败：' + data.msg)
      alert('初始化失败：' + data.msg)
    }
  }).catch((err) => {
    console.error(err)
    alert('初始化异常：' + JSON.stringify(err))
    reportError(JSON.stringify(err))
  })
}

// 记录进入时的url
if (typeof window.entryUrl === 'undefined' || window.entryUrl === '') {
  window.entryUrl = location.href.split('#')[0]
}
